
























import {Component, Vue, Watch} from "vue-property-decorator";
import Loader from '@/components/Loader.vue'
import IdCard from '@/components/IdCard.vue'
import {Response} from "request";
import ApiClient from "@/ApiClient";
import PersonResponse from "@/model/PersonResponse";
import EnhancedPersonResponse from "@/model/EnhancedPersonResponse";

@Component({
    components: {Loader, IdCard}
})
export default class IdCardCollection extends Vue {

    loading = false;
    stat: EnhancedPersonResponse[] = [];
    error = null;

    mounted() {
        this.loadData(this.$route.params.id)
    }

    @Watch('$route.params.id')
    onRouteChanged(val: string) {
        this.$log.debug("route changed");
        this.loadData(val);
    }

    private loadData(tag: string) {
        this.$log.debug("Loading data for tag ", tag);
        this.error = null;
        this.loading = true;

        ApiClient.loadPeopleFromCommunity(tag, (error: any, response: Response, body: any) => {
            this.loading = false;
            if (error) {
                this.$log.error("Can't retrieve data");
                this.$log.error(error);
                this.error = error;
                this.loading = false;
            } else {
                let raw_data: PersonResponse[] = JSON.parse(body).list;
                this.stat = this.shuffle(ApiClient.convertPersonListToEnhancedPersonList(raw_data,tag));
                this.$log.debug('content retrieved: ', this.stat);
            }
        });

    }
    shuffle(a:any[]) {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }

    updated() {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been re-rendered
            // @ts-ignore
            window.$(".zoomTarget").zoomTarget();
        })
    }

}

